// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "ShopAdd" + "." + "c4e1d2d1" + ".js";
};